import { _DeepReadonlyArray } from 'utility-types/dist/mapped-types';

// The following enum corresponds to https://bitbucket.org/pecteam/aion-authorization-resources/src/master/AION.AuthorizationResources/OrganizationFeatures.cs
export enum OrganizationFeature {
  Client = 'Client',
  Subscriber = 'Subscriber',
  PrimeContractor = 'PrimeContractor',
  Subcontractor = 'Subcontractor',
  Questionnaire = 'Questionnaire',
  BusinessUnits = 'BusinessUnits',
  MinimumStandardsReports = 'MinimumStandardsReports',
  DeficiencyReports = 'DeficiencyReports',
  Qualifications = 'Qualifications',
  Smart = 'Smart',
  RanksOrganizations = 'RanksOrganizations',
  RegionMetrics = 'RegionMetrics',
  OperationalMetrics = 'OperationalMetrics',
  IncidentReports = 'IncidentReports',
  RegionMetricsWithoutTotal = 'RegionMetricsWithoutTotal',
  TrainingCompliance = 'TrainingCompliance',
  LinkVeriforceCompany = 'LinkVeriforceCompany',
  Experian = 'Experian',
  FlexTrack = 'FlexTrack',
  EmployeeDrugandAlcoholReport = 'EmployeeDrugandAlcoholReport',
  DrugandAlcoholDataFeed = 'DrugandAlcoholDataFeed',
  Esignature = 'ESignature',
  SamlSso = 'SamlSso',
  StudentEmergencyContactListReport = 'StudentEmergencyContactListReport',
  VeriforceConnect = 'VeriforceConnect',
  EmployeeLinkManagement = 'EmployeeLinkManagement',
  ViewVeriforceConnect = 'ViewVeriforceConnect',
  PredictiveRankingsDashboard = 'PredictiveRankingsDashboard',
  VeriforceOQThirdPartyModule = 'VeriforceOQThirdPartyModule',
  VeriforceDAThirdPartyModule = 'VeriforceDAThirdPartyModule',
  VeriforceTMThirdPartyModule = 'VeriforceTMThirdPartyModule',
  DISAThirdPartyModule = 'DISAThirdPartyModule',
  NCMSThirdPartyModule = 'NCMSThirdPartyModule',
  ASAPThirdPartyModule = 'ASAPThirdPartyModule',
  ContractorReviews = 'ContractorReviews',
  VerisourceOQNavigation = 'VerisourceOQNavigation',
  VerisourceDANavigation = 'VerisourceDANavigation',
  VerisourceTMNavigation = 'VerisourceTMNavigation',
  VerisourceEmployeeOQNavigation = 'VerisourceEmployeeOQNavigation',
  VerisourceContractorOQNavigation = 'VerisourceContractorOQNavigation',
  FormBuilder = 'FormBuilder',
  WorkersCompensation = 'WorkersCompensation',
  NCMSClientRequiredDataFeed = 'NCMSClientRequiredDataFeed',
  ExemptFromBilling = 'ExemptFromBilling',
  PreQualificationGroups = 'PreQualificationGroups',
  QuestionnaireV2 = 'QuestionnaireV2',
  VeriforceLearnAccess = 'VeriforceLearnAccess',
  ComplianceUSA = 'ComplianceUSA',
  ComplianceAUS = 'ComplianceAUS',
  ComplianceUK = 'ComplianceUK',
  ComplianceGlobal = 'ComplianceGlobal',
  ManageHiringClientConnections = 'ManageHiringClientConnections',
  ChasOrganizationFields = 'ChasOrganizationFields',
  GlobalWorkerPass = 'GlobalWorkerPass',
  SupplyChainV2 = 'SupplyChainV2',
  ActivityFeed = 'ActivityFeed',
  ActivityFeedSms = 'ActivityFeedSms',
  Documents = 'Documents',
  NewDashboard = 'NewDashboard',
  ChasNotifications = 'ChasNotifications',
  DovetailCohortZero = 'DovetailCohortZero',
  NgqeLegacyScoringDiscrepancies = 'NgqeLegacyScoringDiscrepancies',
  VerificationsSystemMaintenance = 'VerificationsSystemMaintenance',
  ESGContractor = 'ESGContractor',
  ProcessAutomation = 'ProcessAutomation',
  UnlockModulesBasedOnPreviousDocExpiryDate = 'UnlockModulesBasedOnPreviousDocExpiryDate',
  ClientDashboardNavigation = 'ClientDashboardView',
  VerificationStatusExternalSource = 'VerificationStatusExternalSource',
  RecurringBillingEnabled = 'RecurringBillingEnabled',
  EnabledBankTransfer = 'EnabledBankTransfer',
  QuestionnaireOSHAViolationIntegration = 'QuestionnaireOSHAViolationIntegration'
}

export enum OrganizationType {
  Standard = 'Standard',
  Global = 'Global'
}

type OrganizationRegistrationNumber = {
  typeId: number;
  value: string | null;
};

export interface IOrganization {
  name: string;
  id: string;
  features: OrganizationFeature[];
  verticalId?: string;
  logoUrl?: string | null;
  description?: string | null;
  primaryAddress: string | null;
  secondaryAddress: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  zipCode: string | null;
  phoneNumber: string | null;
  contactPhoneNumber?: string | null;
  phoneNumberExtension: string | null;
  emailAddress: string | null;
  clientFeatures: string[] | null;
  contactEmailAddress?: string | null;
  contactName?: string | null;
  organizationRegistrationNumbers?: _DeepReadonlyArray<OrganizationRegistrationNumber>;
  isStandard?: boolean;
}

export interface IOrganizationFeature {
  name: OrganizationFeature;
  friendlyName: string;
  isLegacyFeature: boolean;
}
